import { render, staticRenderFns } from "./AdminApply.vue?vue&type=template&id=5b266dde&scoped=true&"
import script from "./AdminApply.vue?vue&type=script&lang=js&"
export * from "./AdminApply.vue?vue&type=script&lang=js&"
import style0 from "./AdminApply.vue?vue&type=style&index=0&id=5b266dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b266dde",
  null
  
)

export default component.exports